import {
    FETCH_ALL_APPROACH_GOLF_STATS,
    FETCH_ALL_APPROACH_GOLF_STATS_SUCCESS,
    FETCH_FILTERED_APPROACH_GOLF_STATS,
    FETCH_FILTERED_APPROACH_GOLF_STATS_SUCCESS,
    SET_APPROACH_GOLF_STATS_FILTER
} from '../../actions/ActionTypes.js';

import { isNull, isUndefined } from 'utils/nodash';

// filtered - filtered for clubs
// gdpr safe - intended for unity, remove sensitive data for GDPR purposes

const INITIAL_STATE = {
    isFetching: false,
    payload: {},
    filteredPayload: {},
    gdprSafePayload: {},
    gdprSafeFilteredPayload: {},
    allClubIds: [],
    clubIdsSelected: [],
    areClubIdsSaved: true
};

const fetchAllApproachGolfStatsSuccess = (state, action) => {
    let clubIds = new Set();
    if (action.approachGolfStats.shotOrientationDetail) {
        action.approachGolfStats.shotOrientationDetail.forEach((shotOrientation) => {
            if (clubIds.has(shotOrientation.clubId)) {
                return false;
            }
            clubIds.add(shotOrientation.clubId);
            return true;
        });
    }

    return {
        isFetching: false,
        payload: action.approachGolfStats,
        gdprSafePayload: filterForGDPR(action.approachGolfStats),
        filteredPayload: action.approachGolfStats,
        gdprSafeFilteredPayload: filterForGDPR(action.approachGolfStats),
        allClubIds: [...clubIds],
        clubIdsSelected: [],
        areClubIdsSaved: true
    };
};

const fetchFilteredApproachGolfStatsSuccess = (state, action) => {
    return {
        ...state,
        filteredPayload: action.approachGolfStats,
        gdprSafeFilteredPayload: filterForGDPR(action.approachGolfStats)
    };
};

const setApproachGolfStatsFilter = (state, action) => {
    //Only saving to the clubIdsSelected when the user confirms the modal selection for which club they will filter by
    if (action.areClubIdsSaved) {
        return {
            ...state,
            clubIdsSelected: action.clubIdsSelected || []
        };
    } else {
        return {
            ...state,
            unsavedIdsSelected: action.clubIdsSelected || []
        };
    }
};

const handlers = {
    [FETCH_ALL_APPROACH_GOLF_STATS_SUCCESS]: fetchAllApproachGolfStatsSuccess,
    [SET_APPROACH_GOLF_STATS_FILTER]: setApproachGolfStatsFilter,
    [FETCH_FILTERED_APPROACH_GOLF_STATS_SUCCESS]: fetchFilteredApproachGolfStatsSuccess
};

export default function approachGolfStats(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// Actions
export function fetchAllApproachGolfStats() {
    return {
        type: FETCH_ALL_APPROACH_GOLF_STATS,
        isFetching: true
    };
}

export function fetchFilteredApproachGolfStats(clubIds) {
    return {
        type: FETCH_FILTERED_APPROACH_GOLF_STATS,
        isFetching: true,
        clubIds: clubIds
    };
}

export const getApproachGolfStats = (state) => {
    return state.approachGolfStats;
};

const filterForGDPR = (approachGolfStats) => {
    // intended for use with Unity cntainer, GDPR compliant

    const dispersionDetails = approachGolfStats.shotOrientationDetail
        ? approachGolfStats.shotOrientationDetail.map((shot) => {
              return {
                  shotId: shot.shotId,
                  holeNumber: shot.holeNumber,
                  clubId: shot.clubId,
                  endingLieType: shot.endingLieType,
                  offsetAngle: shot.offsetAngle,
                  remainingDistance: shot.remainingDistance,
                  startingDistanceToHole: shot.startingDistanceToHole,
                  startingLieType: shot.startingLieType,
                  strokesGained: shot.strokesGained
              };
          })
        : undefined;

    let usingClubtrack = false;
    /*  CA-59854 GOLFAPP-5197 per Casey Stalnaker:
        If the original json returned from the endpoint contains properties percentHitGreen10, percentHitGreen20, or percentHitGreen20+
        we know that the user has CT10 or other shot tracking sensors. In this case we should force the usingClubTrack boolean to true.
        This setting will ensure that we are showing concentric rings in the approach chart inside of Unity.
        */
    if (
        (!isNull(approachGolfStats.percentHitGreen10) && !isUndefined(approachGolfStats.percentHitGreen10)) ||
        (!isNull(approachGolfStats.percentHitGreen20) && !isUndefined(approachGolfStats.percentHitGreen20)) ||
        (!isNull(approachGolfStats.percentHitGreen20Plus) && !isUndefined(approachGolfStats.percentHitGreen20Plus))
    ) {
        usingClubtrack = true;
    }

    return {
        usingClubtrack: usingClubtrack,
        usingClubTrack: usingClubtrack, // unity container used improper casing, fix it here instead of creating new unity build
        percentHitGreen: approachGolfStats.percentHitGreen,
        percentHitGreen10: approachGolfStats.percentHitGreen10,
        percentHitGreen20: approachGolfStats.percentHitGreen20,
        percentHitGreen20Plus: approachGolfStats.percentHitGreen20Plus,
        percentLeftOfGreen: approachGolfStats.percentLeftOfGreen,
        percentLongOfGreen: approachGolfStats.percentLongOfGreen,
        percentMissedGreen: approachGolfStats.percentMissedGreen,
        percentRightOfGreen: approachGolfStats.percentRightOfGreen,
        percentShortOfGreen: approachGolfStats.percentShortOfGreen,
        shotOrientationDetail: dispersionDetails
    };
};
